export const links = {
  docs: {
    eMode: 'https://docs.spark.fi/user-guides/using-sparklend/e-mode',
    isolationMode: 'https://docs.spark.fi/user-guides/using-sparklend/#isolation-mode',
    siloedMode: 'https://docs.spark.fi/user-guides/using-sparklend/#supply-and-borrow-caps',
    isolationModeBorrowingPower: 'https://docs.spark.fi/user-guides/using-sparklend/isolation-mode',
    supplyBorrowCaps: 'https://docs.spark.fi/user-guides/using-sparklend/#supply-and-borrow-caps',
    healthFactor: 'https://docs.spark.fi/user-guides/using-sparklend/borrowing-assets#what-is-the-health-factor',
    supplying: 'https://docs.spark.fi/user-guides/using-sparklend/depositing-assets#how-much-will-i-earn',
    borrowing: 'https://docs.spark.fi/user-guides/using-sparklend/borrowing-assets#how-much-will-i-pay-in-interest',
    farmingRewards: 'https://docs.spark.fi/user-guides/farming-rewards',
    savings: {
      upgradeSdai: 'https://docs.spark.fi/user-guides/upgrading-to-usds-and-susds/upgrading-to-susds',
      newSavings: 'https://docs.spark.fi/user-guides/upgrading-to-usds-and-susds',
      susds: 'https://docs.spark.fi/user-guides/earning-savings/susds',
      susdc: 'https://docs.spark.fi/user-guides/earning-savings/susdc',
      sdai: 'https://docs.spark.fi/user-guides/earning-savings/sdai',
      stusds: 'https://docs.spark.fi/staking/stusds',
      withdrawSavings: 'https://docs.spark.fi/user-guides/earning-savings/#withdraw-savings',
      sparkPSM: 'https://docs.spark.fi/user-guides/spark-liquidity-layer/#cross-chain-liquidity-using-spark-psm',
      gnosisSdai: 'https://docs.spark.fi/user-guides/earning-savings/sdai#savings-xdai-on-gnosis-chain',
      earningSavings: 'https://docs.spark.fi/user-guides/earning-savings',
      spusdc: 'https://docs.spark.fi/user-guides/earning-savings/spusdc',
      spusdt: 'https://docs.spark.fi/user-guides/earning-savings/spusdt',
      speth: 'https://docs.spark.fi/user-guides/earning-savings/speth',
      legacy: 'https://docs.spark.fi/user-guides/earning-savings',
    },
    sparkRewards: 'https://docs.spark.fi/rewards',
    spkStaking: 'https://docs.spark.fi/staking',
    stakingRisks: 'https://docs.spark.fi/staking#what-are-the-risks',
    spkFarming: 'https://docs.spark.fi/governance/spk-token#sky-farming-users',
    airdrop: {
      summary: 'https://docs.spark.fi/airdrop',
      preFarming: 'https://docs.spark.fi/airdrop/pre-farm',
      ignition: 'https://docs.spark.fi/airdrop/ignition',
      overdrive: 'https://docs.spark.fi/airdrop/overdrive',
      layer3: 'https://docs.spark.fi/airdrop/layer3',
    },
    governance: 'https://docs.spark.fi/user-guides/governance',
    spkToken: 'https://docs.spark.fi/governance/spk-token',
    points: 'https://docs.spark.fi/points',
    swap: 'https://docs.spark.fi/user-guides/swap/',
    sparkLiquidityLayer: 'https://docs.spark.fi/user-guides/spark-liquidity-layer',
    micaWhitepaper: 'https://docs.spark.fi/mica',
  },
  sparkExternal: {
    termsOfUse: 'https://spark.fi/terms-of-use',
    privacyPolicy: 'https://spark.fi/privacy-policy',
    pointsLeaderboard: 'https://points.spark.fi',
    sparkLiquidityLayerData: 'https://data.spark.fi/spark-liquidity-layer',
    dataDashboard: 'https://data.spark.fi',
    dataDashboardSavings: 'https://data.spark.fi/savings',
  },
  aaveTechnicalPaper: 'https://github.com/aave/aave-v3-core/blob/master/techpaper/Aave_V3_Technical_Paper.pdf',
  pendleWebsite: 'https://app.pendle.finance/trade/pools/0xdace1121e10500e9e29d071f01593fd76b000f08',
  social: {
    x: 'https://x.com/sparkdotfi',
  },
  snapshot: {
    sparkSpace: 'https://snapshot.box/#/s:sparkfi.eth',
    proposals: 'https://snapshot.box/#/s:sparkfi.eth/proposals',
  },
  appSky: {
    farms: {
      all: 'https://app.sky.money/?network=ethereum&widget=rewards',
      usdsToSky:
        'https://app.sky.money/?network=ethereum&widget=rewards&reward=0x0650CAF159C5A49f711e8169D4336ECB9b950275',
      usdsToClePoints:
        'https://app.sky.money/?network=ethereum&widget=rewards&reward=0x10ab606B067C9C461d8893c47C7512472E19e2Ce',
    },
  },
} as const
